import { Alert, SimpleGrid, Stack } from '@mantine/core';
import { mapApiToThecData } from './helpers';
import { useDashboardSectionData } from '../hooks/useDashboardSectionData';
import { PerformanceCardSkeleton } from '../PerformanceCardSkeleton';
import { AcademicCreditCard } from './cards/AcademicCreditCard';
import { JobPlacementCard } from './cards/JobPlacementCard';
import { ProgramCompletionCard } from './cards/ProgramCompletionCard';
import { ProgramParticipantsCard } from './cards/ProgramParticipantsCard';
import { RepresentationCard } from './cards/RepresentationCard';
import { SatisfactionCard } from './cards/SatisfactionCard';

export function ThecPerformanceMetrics() {
  const { mappedData: thecData, error, isLoading } = useDashboardSectionData({
    queryKey: 'thec',
    fallbackGroupId: 'THEC',
    enabled: (group) => group === 'THEC',
    mapData: mapApiToThecData,
  });

  return (
    <Stack spacing="lg">
      {error ? (
        <Alert color="yellow" variant="light">
          Unable to load dashboard API data.
        </Alert>
      ) : null}
      {!isLoading && !thecData ? (
        <Alert color="yellow" variant="light">
          No dashboard API data returned for this section.
        </Alert>
      ) : null}
      {isLoading && !thecData ? (
        <SimpleGrid
          cols={2}
          spacing="lg"
          breakpoints={[
            { maxWidth: 1200, cols: 2 },
            { maxWidth: 900, cols: 1 },
          ]}
        >
          <div style={{ gridColumn: '1 / -1' }}>
            <PerformanceCardSkeleton />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <PerformanceCardSkeleton />
          </div>
          <PerformanceCardSkeleton />
          <PerformanceCardSkeleton />
          <div style={{ gridColumn: '1 / -1' }}>
            <PerformanceCardSkeleton />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <PerformanceCardSkeleton />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <PerformanceCardSkeleton />
          </div>
        </SimpleGrid>
      ) : null}
      {thecData ? (
        <SimpleGrid
          cols={2}
          spacing="lg"
          breakpoints={[
            { maxWidth: 1200, cols: 2 },
            { maxWidth: 900, cols: 1 },
          ]}
        >
          <div style={{ gridColumn: '1 / -1' }}>
            <ProgramParticipantsCard data={thecData} />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <ProgramCompletionCard data={thecData} />
          </div>
          <AcademicCreditCard data={thecData} />
          <JobPlacementCard data={thecData} />
          <div style={{ gridColumn: '1 / -1' }}>
            <SatisfactionCard data={thecData} kind="employer" />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <SatisfactionCard data={thecData} kind="participant" />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <RepresentationCard data={thecData} />
          </div>
        </SimpleGrid>
      ) : null}
    </Stack>
  );
}
